import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { BehaviorSubject } from "rxjs";
import { TranslateService } from "@ngx-translate/core";
@Component({
    selector: "app-holding-screen",
    templateUrl: "./holding-screen.component.html",
    styleUrls: ["./holding-screen.component.scss"],
    standalone: true,
})
export class HoldingScreenComponent implements OnInit {
  seedingPending = [];
  seedingComplete = [];
  completed$ = new BehaviorSubject(false);
  selectedLanguage: string = "en";
  redirectTo: any;

  constructor(
    private authService: AuthService,
    private router: Router,
    public translate: TranslateService,
    private route: ActivatedRoute
  ) {
    this.authService?.selectedlanguage$?.subscribe(
      (l) => {
        this.selectedLanguage = l ? l : "en";
        if (l) {
          translate.use(l ? l : "en");
        }
      },
      (err) => {
        return err;
      }
    );

    this.authService?.holdingMessage$?.subscribe(
      (data: any) => {
        if (!data || !data?.seed_complete) return;
        this.seedingComplete = data?.seed_complete;
        let i = 0;
        this.seedingPending = data[`h${i + 1}`];
        setInterval(() => {
          this.seedingPending = data[`h${i + 2}`];

          if (i === 7) {
            i = -1;
          }
          i++;
        }, 4000);
      },
      (err) => {
        return err;
      }
    );
  }

  ngOnInit() {
    this.redirectTo = this.route.snapshot.queryParams["redirectTo"] || "/mainTabs/tabs/home";
    this.authService?.userDetails$?.subscribe(
      (user: any) => {
        if (user?.seeding === "completed") {
          this.completed$.next(true);
          setTimeout(() => {
            this.router.navigateByUrl(this.redirectTo);
          }, 2000);
        }
      },
      (err) => {
        return err;
      }
    );
  }
}
